import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, assetUrl } from "../lib/api";
import { MapPin, ArrowRight, ExternalLink } from "lucide-react";
import Reveal from "../components/site/Reveal";
import { useReveal } from "../lib/useReveal";

const Builders = () => {
  const [builders, setBuilders] = useState([]);
  useEffect(() => {
    api.get("/builders").then((r) => setBuilders(r.data)).catch(() => {});
  }, []);
  useReveal([builders.length]);

  return (
    <div className="pt-[64px] bg-[#12201A] min-h-screen">
      <div className="max-w-[1500px] mx-auto px-5 md:px-8 py-14">
        <p className="eyebrow text-[#C9B79C] mb-3">Our Builders</p>
        <Reveal as="h1" className="font-display font-light text-4xl md:text-5xl text-[#F3EEE3]">Custom Home Builders</Reveal>
        <p className="text-[#F3EEE3]/60 mt-3 max-w-2xl">
          Trusted custom home builders crafting homes at Deer Park Estates in Spruce Grove, Alberta.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {builders.map((b, i) => {
            const cover = b.gallery?.[0] || b.logo_url;
            return (
              <Link
                key={b.id}
                to={`/builders/${b.id}`}
                data-testid={`builder-card-${b.name.split(" ")[0].toLowerCase()}`}
                style={{ transitionDelay: `${(i % 3) * 80}ms` }}
                className="reveal group rounded-2xl overflow-hidden border border-[#F3EEE3]/12 bg-[#0F1B15] hover:border-[#C9B79C]/40 transition-colors"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-[#0C1510]">
                  {cover ? (
                    <img src={assetUrl(cover)} alt={b.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center font-display text-2xl text-[#F3EEE3]/40 px-4 text-center">{b.name}</div>
                  )}
                  {b.logo_url && (
                    <div className="absolute top-3 left-3 w-14 h-14 rounded-xl overflow-hidden border border-[#F3EEE3]/20 shadow-lg">
                      <img src={assetUrl(b.logo_url)} alt={`${b.name} logo`} className="w-full h-full object-cover" />
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <p className="font-display text-xl text-[#F3EEE3]">{b.name}</p>
                  <p className="text-[#F3EEE3]/45 text-xs flex items-center gap-1 mt-1"><MapPin size={11} className="text-[#C9B79C]" /> {b.locale}</p>
                  <p className="text-[#F3EEE3]/60 text-sm mt-3 leading-relaxed line-clamp-2">{b.tagline || b.description}</p>
                  <div className="flex items-center justify-between mt-4">
                    <span className="inline-flex items-center gap-1.5 text-[#C9B79C] text-xs group-hover:gap-2.5 transition-all">View builder <ArrowRight size={13} /></span>
                    {b.website && (
                      <span role="link" tabIndex={0} onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.open(b.website, "_blank", "noopener"); }} className="inline-flex items-center gap-1 text-[#F3EEE3]/60 text-xs hover:text-[#F3EEE3] cursor-pointer">Website <ExternalLink size={12} /></span>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Builders;
